import { lazy } from "react";
import type { Contact } from "../types";

const ContactList = lazy(() =>
  import("./ContactList").then((m) => ({ default: m.ContactList })),
);
const ContactShow = lazy(() =>
  import("./ContactShow").then((m) => ({ default: m.ContactShow })),
);
const ContactEdit = lazy(() =>
  import("./ContactEdit").then((m) => ({ default: m.ContactEdit })),
);
const ContactCreate = lazy(() =>
  import("./ContactCreate").then((m) => ({ default: m.ContactCreate })),
);

export default {
  list: ContactList,
  show: ContactShow,
  edit: ContactEdit,
  create: ContactCreate,
  // Ikke lazy: brukes av datalaget til å vise navnet på en referanse,
  // uavhengig av om kontaktsiden er lastet.
  recordRepresentation: (record: Contact) =>
    record?.first_name + " " + record?.last_name,
};
